import { locale as datelabel } from '@core-pipes/date-label/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...datelabel.data
    }
};